import Table from './Table';
import TableBody from './TableBody';
import TableCell from './TableCell';
import TableHead from './TableHead';
import TableHeaderCell from './TableHeaderCell';
import TableRow from './TableRow';
import TableSortableHeaderCell from './TableSortableHeaderCell';
var ComposedTable = Table;
ComposedTable.Body = TableBody;
ComposedTable.Row = TableRow;
ComposedTable.Cell = TableCell;
ComposedTable.Head = TableHead;
ComposedTable.HeaderCell = TableHeaderCell;
ComposedTable.SortableHeaderCell = TableSortableHeaderCell;
export default ComposedTable;